


































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component
export default class DataTableBankCredit extends Vue {

	headers = [
		{ text: "No.", value: "no", width: 10 ,sortable: false, class: "bankcredit-column-no", align: "center bankcredit-column-no" },
		{ text: "โครงการ", value: "projectNameTh", width: 300 ,sortable: false, class: "bankcredit-column-0", align: "start bankcredit-column-0" },
		{ text: "ยูนิต", value: "unitCode", width: 150 ,sortable: false, class: "bankcredit-column-0", align: "center bankcredit-column-0" },

		{ text: "เลือกใช้", value: "scbUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-1", align: "center bankcredit-column-1" },
		{ text: "วงเงินอนุมัติ", value: "scbApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-1" },
		{ text: "ธนาคาร SCB", value: "scbBankId", width: 350 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่ยื่นกู้", value: "scbRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่อนุมัติ", value: "scbApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "สถานะสินเชื่อ", value: "scbCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "scbCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "หมายเหตุธนาคาร", value: "scbCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-1" },

		{ text: "เลือกใช้", value: "bblUsedBankId", width: 100 ,sortable: false, align: "center bankcredit-column-2" },
		{ text: "วงเงินอนุมัติ", value: "bblApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-2" },
		{ text: "ธนาคาร BBL", value: "bblBankId", width: 350 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่ยื่นกู้", value: "bblRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่อนุมัติ", value: "bblApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "สถานะสินเชื่อ", value: "bblCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "bblCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "หมายเหตุธนาคาร", value: "bblCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-2" },

		{ text: "เลือกใช้", value: "ktbUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-1", align: "center bankcredit-column-1" },
		{ text: "วงเงินอนุมัติ", value: "ktbApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-1" },
		{ text: "ธนาคาร KTB", value: "ktbBankId", width: 350 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่ยื่นกู้", value: "ktbRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่อนุมัติ", value: "ktbApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "สถานะสินเชื่อ", value: "ktbCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "ktbCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "หมายเหตุธนาคาร", value: "ktbCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-1" },

		{ text: "เลือกใช้", value: "kbankUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-2", align: "center bankcredit-column-2" },
		{ text: "วงเงินอนุมัติ", value: "kbankApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-2" },
		{ text: "ธนาคาร KBANK", value: "kbankBankId", width: 350 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่ยื่นกู้", value: "kbankRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่อนุมัติ", value: "kbankApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "สถานะสินเชื่อ", value: "kbankCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "kbankCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "หมายเหตุธนาคาร", value: "kbankCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-2" },

		{ text: "เลือกใช้", value: "ttbUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-1", align: "center bankcredit-column-1" },
		{ text: "วงเงินอนุมัติ", value: "ttbApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-1" },
		{ text: "ธนาคาร TTB", value: "ttbBankId", width: 350 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่ยื่นกู้", value: "ttbRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่อนุมัติ", value: "ttbApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "สถานะสินเชื่อ", value: "ttbCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "ttbCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "หมายเหตุธนาคาร", value: "ttbCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-1" },

		{ text: "เลือกใช้", value: "bayUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-2", align: "center bankcredit-column-2" },
		{ text: "วงเงินอนุมัติ", value: "bayApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-2" },
		{ text: "ธนาคาร BAY", value: "bayBankId", width: 350 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่ยื่นกู้", value: "bayRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่อนุมัติ", value: "bayApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "สถานะสินเชื่อ", value: "bayCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "bayCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "หมายเหตุธนาคาร", value: "bayCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-2" },

		{ text: "เลือกใช้", value: "ghbUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-1", align: "center bankcredit-column-1" },
		{ text: "วงเงินอนุมัติ", value: "ghbApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-1" },
		{ text: "ธนาคาร GHB", value: "ghbBankId", width: 350 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่ยื่นกู้", value: "ghbRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่อนุมัติ", value: "ghbApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "สถานะสินเชื่อ", value: "ghbCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "ghbCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "หมายเหตุธนาคาร", value: "ghbCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-1" },

		{ text: "เลือกใช้", value: "gsbUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-2", align: "center bankcredit-column-2" },
		{ text: "วงเงินอนุมัติ", value: "gsbApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-2" },
		{ text: "ธนาคาร GSB", value: "gsbBankId", width: 350 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่ยื่นกู้", value: "gsbRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "วันที่อนุมัติ", value: "gsbApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "สถานะสินเชื่อ", value: "gsbCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "gsbCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-2" },
		{ text: "หมายเหตุธนาคาร", value: "gsbCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-2" },

		{ text: "เลือกใช้", value: "uobUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-1", align: "center bankcredit-column-1" },
		{ text: "วงเงินอนุมัติ", value: "uobApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-1" },
		{ text: "ธนาคาร UOB", value: "uobBankId", width: 350 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่ยื่นกู้", value: "uobRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "วันที่อนุมัติ", value: "uobApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "สถานะสินเชื่อ", value: "uobCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "uobCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-1" },
		{ text: "หมายเหตุธนาคาร", value: "uobCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-1" },

		{ text: "เลือกใช้", value: "otherUsedBankId", width: 100 ,sortable: false, class: "bankcredit-column-3", align: "center bankcredit-column-3" },
		{ text: "วงเงินอนุมัติ", value: "otherApproveFinanceAmt", width: 130 ,sortable: false, align: "end bankcredit-column-3" },
		{ text: "ธนาคารอื่นๆ", value: "otherBankId", width: 350 ,sortable: false, align: "start bankcredit-column-3" },
		{ text: "วันที่ยื่นกู้", value: "otherRecoverDate", width: 180 ,sortable: false, align: "start bankcredit-column-3" },
		{ text: "วันที่อนุมัติ", value: "otherApproveDate", width: 180 ,sortable: false, align: "start bankcredit-column-3" },
		{ text: "สถานะสินเชื่อ", value: "otherCreditStatusId", width: 180 ,sortable: false, align: "start bankcredit-column-3" },
		{ text: "เหตุผลสถานะสินเชื่อ", value: "otherCreditReasonStatusId", width: 300 ,sortable: false, align: "start bankcredit-column-3" },
		{ text: "หมายเหตุธนาคาร", value: "otherCrRemarkBank", width: 300 ,sortable: false, align: "start bankcredit-column-3" },
	]
	options = { itemsPerPage: 10 } as any
	footerProps = { 'items-per-page-options': [10, 15, 30, 50] } as any

	selected = [] as any[]
	tableData = [] as any[]

	setDataTable (reportInspectionPlanning: any[]) {
		this.tableData = reportInspectionPlanning.map((x, i) => {
			x.no = i+1
			x.planPJDate = x.planPJDate != "" ? dayjs(x.planPJDate).format("DD/MM/YYYY") : ""
			x.planCRDate = x.planCRDate != "" ? dayjs(x.planCRDate).format("DD/MM/YYYY") : ""
			x.transferDate = x.transferDate != "" ? dayjs(x.transferDate).format("DD/MM/YYYY") : ""
			x.letterDate = x.letterDate != "" ? dayjs(x.letterDate).format("DD/MM/YYYY") : ""
			return x
		})
	}

	clearDataTable () {
		this.tableData = []
	}
}


export interface IDataTableBankCredit {
    no: number;
    unitCode: string;
    projectNameTh: string;
    scbUsedBankId: boolean;
    scbBankId: string;
    scbApproveFinanceAmt: string;
    scbInterest: string;
    scbApproveCreditPercent: string;
    scbCreditStatusId: string;
    scbCreditReasonStatusId: string;
    scbCrRemarkBank: string;
	scbRecoverDate: string;
	scbApproveDate: string;


    bblUsedBankId: boolean;
    bblBankId: string;
    bblApproveFinanceAmt: string;
    bblInterest: string;
    bblApproveCreditPercent: string;
    bblCreditStatusId: string;
    bblCreditReasonStatusId: string;
    bblCrRemarkBank: string;
	bblRecoverDate: string;
	bblApproveDate: string;


    ktbUsedBankId: string;
    ktbBankId: string;
    ktbApproveFinanceAmt: string;
    ktbInterest: string;
    ktbApproveCreditPercent: string;
    ktbCreditStatusId: string;
    ktbCreditReasonStatusId: string;
    ktbCrRemarkBank: string;
	ktbRecoverDate: string;
	ktbApproveDate: string;


    kbankUsedBankId: string;
    kbankBankId: string;
    kbankApproveFinanceAmt: string;
    kbankInterest: string;
    kbankApproveCreditPercent: string;
    kbankCreditStatusId: string;
    kbankCreditReasonStatusId: string;
    kbankCrRemarkBank: string;
	kbankRecoverDate: string;
	kbankApproveDate: string;


    ttbUsedBankId: string;
    ttbBankId: string;
    ttbApproveFinanceAmt: string;
    ttbInterest: string;
    ttbApproveCreditPercent: string;
    ttbCreditStatusId: string;
    ttbCreditReasonStatusId: string;
    ttbCrRemarkBank: string;
	ttbRecoverDate: string;
	ttbApproveDate: string;


    bayUsedBankId: string;
    bayBankId: string;
    bayApproveFinanceAmt: string;
    bayInterest: string;
    bayApproveCreditPercent: string;
    bayCreditStatusId: string;
    bayCreditReasonStatusId: string;
    bayCrRemarkBank: string;
	bayRecoverDate: string;
	bayApproveDate: string;


    ghbUsedBankId: string;
    ghbBankId: string;
    ghbApproveFinanceAmt: string;
    ghbInterest: string;
    ghbApproveCreditPercent: string;
    ghbCreditStatusId: string;
    ghbCreditReasonStatusId: string;
    ghbCrRemarkBank: string;
	ghbRecoverDate: string;
	ghbApproveDate: string;


    gsbUsedBankId: string;
    gsbBankId: string;
    gsbApproveFinanceAmt: string;
    gsbInterest: string;
    gsbApproveCreditPercent: string;
    gsbCreditStatusId: string;
    gsbCreditReasonStatusId: string;
    gsbCrRemarkBank: string;
	gsbRecoverDate: string;
	gsbApproveDate: string;


    uobUsedBankId: string;
    uobBankId: string;
    uobApproveFinanceAmt: string;
    uobInterest: string;
    uobApproveCreditPercent: string;
    uobCreditStatusId: string;
    uobCreditReasonStatusId: string;
    uobCrRemarkBank: string;
	uobRecoverDate: string;
	uobApproveDate: string;


    otherUsedBankId: boolean;
    otherBankId: string;
    otherApproveFinanceAmt: string;
    otherInterest: string;
    otherApproveCreditPercent: string;
    otherCreditStatusId: string;
    otherCreditReasonStatusId: string;
    otherCrRemarkBank: string;
	otherRecoverDate: string;
	otherApproveDate: string;

}
